import styled from "styled-components";

export const StyledBreakWord = styled.div`
  width: 100%;
  overflow-wrap: break-word;
  text-align: left;
  word-wrap: anywhere;
`;